export default (value: any) => {
    if(value === true){
        return "Si"
    }else{
        return "No"
    }
}